<template>
  <div class="filter-list">
    <div class="filter keyword">
      <el-input v-model="search.keyword" clearable class="keyword-input" prefix-icon="el-icon-search" :placeholder="$t('company.placeholder.searchJobs')" @change="onKeywordChange"></el-input>
    </div>
    <div
      v-for="(filter, index) in filterList"
      class="filter"
      :class="activeIds.includes(filter.id) && 'is-active'"
      :key="index"
    >
      <div class="title-container" @click="onFilterClick($event, filter, index)">
        <div class="title">{{ filter.title || $t(filter.titleI18nKey) }}</div>
        <div class="expand-btn">
          <i class="expand-icon el-icon-arrow-down"></i>
        </div>
      </div>
      <div class="content-container" ref="filterOptionListRef" style="height: 0px" :id="`filterOptionList_${filter.id}`" :class="filter.type" @transitionend="onTransitionEnd">
        <template v-if="filter.type === 'text'">
          <el-input class="filter-input"></el-input>
        </template>
        <template v-else>
          <el-input v-if="filter.optionList?.length > 7" v-model="filterSearchOptionListMap[filter.name].optionSearchKey" class="option-search" suffix-icon="el-icon-search" clearable :placeholder="$t(`company.placeholder.searchPlaceholder`, { keyName: filter.title })" @input="searchOption(filter)"></el-input>
          <div class="filter-option-list" :ref="`filterOption_${filter.id}_Ref`">
            <div
              v-auto-tooltip
              v-for="(option) in filterSearchOptionListMap[filter.name].searchedOptionList"
              class="filter-option"
              :key="option.id"
              :class="isSelectedOption(filter, option) && 'is-selected'"
              @click="onOptionClick(filter, option)"
            >
              <span class="label">{{ option.label || $t(option.labelI18nKey) || option[filter.optionLabel] }}</span>
              <span v-if="option.job_count || option.showZeroJobCount" class="job-count">{{ `(${option.job_count})` }}</span>
              <span v-if="isSelectedOption(filter, option)" class="close-btn" @click.stop="onOptionClick(filter, option)"><i class="el-icon-close"></i></span>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    filterList: {
      required: true
    },
    keyword: {
      default: null
    },
    selected: {
      default: null
    },
    selectedFilterId: {
      default: null
    }
  },
  data () {
    return {
      activeIds: [],
      search: {
        keyword: null
      },
      filterSearchOptionListMap: {}
    }
  },
  computed: {
  },
  created () {

  },
  methods: {
    searchOption (filter) {
      const keyword = this.filterSearchOptionListMap[filter.name].optionSearchKey
      const optionList = filter.optionList
      if (keyword) {
        const val = keyword.toUpperCase()
        const keyList = [filter.optionLabel, 'label', 'labelI18nKey', 'cn_name', 'name', 'i18nName']
        if (filter.type === 'location') {
          keyList.push('city.cn_name')
          keyList.push('city.name')
        }
        this.filterSearchOptionListMap[filter.name].searchedOptionList = _.filter(optionList, option => _.some(keyList, key => _.chain(option).get(key).toUpper().includes(val).value()))
      } else {
        this.filterSearchOptionListMap[filter.name].searchedOptionList = optionList
      }
    },
    onFilterClick (e, filter, index) {
      const idIndex = this.activeIds.indexOf(filter.id)
      const isActive = idIndex > -1
      const el = e.currentTarget
      const containerEl = el.nextElementSibling
      if (isActive) {
        if (containerEl.style.height) {
          containerEl.style.height = '0px'
        } else {
          const height = containerEl.clientHeight
          containerEl.style.height = `${height}px`
          setTimeout(() => {
            containerEl.style.height = '0px'
          }, 0)
        }
        this.activeIds.splice(idIndex, 1)
      } else {
        const currentHeight = containerEl.clientHeight
        containerEl.style.height = null
        const height = containerEl.clientHeight
        containerEl.style.height = `${currentHeight}px`
        setTimeout(() => {
          containerEl.style.height = `${height}px`
        }, 0)
        this.activeIds.push(filter.id)
      }
      const filterRef = this.$refs[`filterOption_${filter.id}_Ref`][0]
      const selectIds = this.search[filter.id]
      const optionIndex = _.findIndex(filter.optionList, option => _.includes(selectIds, option.id))
      if (selectIds && optionIndex > -1 && filterRef) {
        filterRef.scrollTop = optionIndex * 30
      }
    },
    onTransitionEnd (e) {
      const el = e.currentTarget
      if (el.style.height !== '0px') {
        el.style.height = null
      }
    },
    isSelectedOption (filter, option) {
      const selectedIds = this.search[filter.id]
      return selectedIds && selectedIds.includes(option.id)
    },
    onKeywordChange () {
      this.$emit('change', 'keyword', this.search.keyword, !this.search.keyword)
    },
    onOptionClick (filter, option) {
      let selectedIds = this.search[filter.id]
      let isRemove = false
      if (selectedIds) {
        const idIndex = selectedIds.indexOf(option.id)
        if (idIndex > -1) {
          selectedIds.splice(idIndex, 1)
          isRemove = true
        } else {
          if (filter.multiple) {
            selectedIds.push(option.id)
          } else {
            this.$set(selectedIds, 0, option.id)
          }
        }
      } else {
        selectedIds = [option.id]
        this.$set(this.search, filter.id, selectedIds)
      }
      this.$emit('change', filter, option, isRemove)
    },
    resetFilterOptionListHeight () {
      _.forEach(this.$refs.filterOptionListRef, (el) => {
        const idStr = el.id
        const filterId = _.parseInt(_.split(idStr, '_')[1])
        const idIndex = this.activeIds.indexOf(filterId)
        if (filterId !== this.selectedFilterId) {
          el.style.height = '0px'
          this.activeIds.splice(idIndex, 1)
        }
      })
    },
    resetSearchParams () {
      this.search = {
        keyword: null
      }
    }
  },
  watch: {
    filterList: {
      immediate: true,
      handler () {
        _.forEach(this.filterList, filter => {
          this.$set(this.filterSearchOptionListMap, filter.name, {
            optionSearchKey: null,
            searchedOptionList: filter.optionList
          })
        })
      }
    },
    keyword: {
      immediate: true,
      handler () {
        this.search.keyword = this.keyword
      }
    },
    selected: {
      immediate: true,
      deep: true,
      handler () {
        if (!_.isEmpty(this.selected)) {
          _.forEach(this.selected, (optionIds, filterId) => {
            optionIds = (optionIds && optionIds.length > 0) ? [...optionIds] : null
            if (_.has(this.search, filterId)) {
              this.search[filterId] = optionIds
            } else {
              this.$set(this.search, filterId, optionIds)
            }
          })
        } else {
          this.resetSearchParams()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-list {
  .filter {
    padding: 24px 0;
    border-bottom: 1px solid #dedfe6;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom-color: transparent;
    }

    &.is-active {
      .title-container {
        .expand-btn {
          .expand-icon {
            transform: rotateZ(180deg);
          }
        }
      }
    }

    .keyword-input {
      ::v-deep {
        .el-input__inner {
          border-color: #e4e7ed;
          &:focus {
            border-color: #c0c4cc;
          }
        }
      }
    }

    .title-container {
      display: flex;
      cursor: pointer;

      .title {
        flex: 1;
      }

      .expand-btn {
        .expand-icon {
          transition: transform .3s ease-in-out;
        }
      }
    }

    .content-container {
      transition: height .3s ease-in-out;
      overflow: hidden;
      color: #606266;

      &::before {
        content: '';
        display: block;
        padding-top: 18px;
      }

      ::v-deep {
        .el-select {
          width: 100%;
        }
      }

      .option-search {
        ::v-deep {
          .el-input__inner {
            border-color: #e4e7ed;
            &:focus {
              border-color: #c0c4cc;
            }
          }
        }
        margin-bottom: 10px;
      }

      .filter-option-list {
        max-height: 230px;
        overflow: auto;
        .filter-option {
          height: 30px;
          line-height: 30px;
          padding: 0 14px;
          cursor: pointer;
          position: relative;

          .label {
          }

          .job-count {
            margin-left: 10px;
            color: #c6c6c6;
          }

          &:hover {
            --rgb-custom-color: rgb(from var(--custom-color) r g b / 5%);
            background: var(--rgb-custom-color);
          }

          &.is-selected {
            color: var(--custom-color);
            --rgb-custom-color: rgb(from var(--custom-color) r g b / 5%);
            background: var(--rgb-custom-color);
          }

          .close-btn {
            position: absolute;
            right: 10px;
          }
        }
      }
    }
  }
}

.location-selector-popper {
  .el-scrollbar {
    .el-select-dropdown__wrap {
      .el-scrollbar__view {
        .el-select-dropdown__item {

          .label {
            vertical-align: middle;
          }

          .job-count {
            margin-left: 10px;
            color: #c6c6c6;
          }

          &:hover {
            --rgb-custom-color: rgb(from var(--custom-color) r g b / 5%);
            background: var(--rgb-custom-color);
          }

          &.selected {
            color: var(--custom-color);
            --rgb-custom-color: rgb(from var(--custom-color) r g b / 5%);
            background: var(--rgb-custom-color);
          }
        }
      }
    }
  }
}
</style>
